import React, { useState, useEffect, useRef } from 'react';
import './Support.css';
import { Link, useNavigate } from 'react-router-dom';
import Trial from './Trial';
import data from './Instant_Demos/supportData'; // Import data from the new supportData.js file

export default function Support() {
    const [showCopyPopup, setShowCopyPopup] = useState(false);
    const navigate = useNavigate();
    // Ref for the hold timer ID
    const holdTimer = useRef(null);
    const HOLD_DURATION_MS = 5000; // 5 seconds

    // Effect for keyboard event listeners (Ctrl to open, Escape to close)
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === 'F9') {
                event.preventDefault(); // Prevent default browser actions for Ctrl key
                setShowCopyPopup(true); // Open the popup
            } else if (event.key === 'Escape') {
                setShowCopyPopup(false); // Close with Escape key
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []); // Empty dependency array: runs once on mount

    // Effect for hold-to-open functionality on mobile
    useEffect(() => {
        const handleTouchStart = () => {
            // Check if it's a mobile device screen width
            if (window.innerWidth <= 768) {
                // Clear any existing timer to prevent multiple timers from running
                if (holdTimer.current) {
                    clearTimeout(holdTimer.current);
                }
                // Start a new timer for the hold duration
                holdTimer.current = setTimeout(() => {
                    setShowCopyPopup(true); // Show the popup when hold duration is met
                    holdTimer.current = null; // Clear the timer ID as it has fired
                }, HOLD_DURATION_MS);
            }
        };

        const handleTouchEnd = () => {
            // Clear the timer if the touch ends before the hold duration is met
            if (holdTimer.current) {
                clearTimeout(holdTimer.current);
                holdTimer.current = null;
            }
        };

        const handleTouchCancel = () => {
            // Clear the timer if the touch is interrupted (e.g., finger moves too much)
            if (holdTimer.current) {
                clearTimeout(holdTimer.current);
                holdTimer.current = null;
            }
        };

        // Add event listeners
        document.addEventListener('touchstart', handleTouchStart);
        document.addEventListener('touchend', handleTouchEnd);
        document.addEventListener('touchcancel', handleTouchCancel);

        // Clean up event listeners and any lingering timer on component unmount
        return () => {
            document.removeEventListener('touchstart', handleTouchStart);
            document.removeEventListener('touchend', handleTouchEnd);
            document.removeEventListener('touchcancel', handleTouchCancel);
            if (holdTimer.current) {
                clearTimeout(holdTimer.current);
            }
        };
    }, []); // Empty dependency array: runs once on mount for listeners

    // Effect to react when recentTapTimestamps state changes - REMOVE THIS useEffect
    // useEffect(() => {
    //     if (recentTapTimestamps.length >= REQUIRED_TAPS) {
    //         setShowCopyPopup(true); // Open the popup
    //         setRecentTapTimestamps([]); // Reset tap count after opening popup
    //     }
    // }, [recentTapTimestamps]);

    // Function to handle copying the link (same as before)
    const handleCopyLink = (slug) => {
        const fullLink = `${window.location.origin}/creation/${slug}`;

        navigator.clipboard.writeText(fullLink)
            .then(() => {
                alert(`Link copied to clipboard: ${fullLink}`);
                setShowCopyPopup(false); // Close popup after copying
            })
            .catch(err => {
                console.error('Failed to copy link: ', err);
                alert('Failed to copy link. Please check console for errors.');
            });
    };

    // Split data into two columns (same as before)
    const mid = Math.ceil(data.length / 2);
    const left = data.slice(0, mid);
    const right = data.slice(mid);

    return (
        <div>
            <div className="support-wrapper">
                <h1 className="timeline-title">Support Center</h1>
                <div className="side-by-side">
                    <div className="timeline-column">
                        {left.map((item, index) => (
                            item.link ? (
                                <Link
                                    to={`${item.link}/${item.slug}`}
                                    key={index}
                                    state={{ steps: item.steps }}
                                >
                                    <div className="support-card">
                                        <h2>{item.title}</h2>
                                        <p>{item.description}</p>
                                    </div>
                                </Link>
                            ) : (
                                <div className="support-card" key={index}>
                                    <h2>{item.title}</h2>
                                    <p>{item.description}</p>
                                </div>
                            )
                        ))}
                    </div>
                    <div className="timeline-column">
                        {right.map((item, index) => (
                            item.link ? (
                                <Link
                                    to={`${item.link}/${item.slug}`}
                                    key={index}
                                    state={{ steps: item.steps }}
                                >
                                    <div className="support-card">
                                        <h2>{item.title}</h2>
                                        <p>{item.description}</p>
                                    </div>
                                </Link>
                            ) : (
                                <div className="support-card" key={index}>
                                    <h2>{item.title}</h2>
                                    <p>{item.description}</p>
                                </div>
                            )
                        ))}
                    </div>
                </div>
            </div>

        

            <Trial />

            {/* Copy Link Popup */}
            {showCopyPopup && (
                <div
                    className="copy-link-popup-overlay"
                    onClick={() => setShowCopyPopup(false)} // Close when clicking outside the content box
                >
                    <div
                        className="copy-link-popup-content"
                        onClick={(e) => e.stopPropagation()} // Prevent overlay click from propagating to content
                    >
                        <h2>Copy Demo Link</h2>
                        <p>Click a button below to copy the link for the specific demo.</p>
                        <div className="link-buttons-container">
                            {data.map((item, index) => (
                                <button
                                    key={index}
                                    className="copy-link-button"
                                    onClick={() => handleCopyLink(item.slug)}
                                >
                                    {item.title} ({item.slug})
                                </button>
                            ))}
                        </div>
                        <button
                            className="close-popup-button"
                            onClick={() => setShowCopyPopup(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}